var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconmaterialDescriptionYellow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.77,
    height: 14.712,
    viewBox: "0 0 11.77 14.712",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-description",
    "data-name": "Icon material-description",
    d: "M11.356,2H5.471A1.469,1.469,0,0,0,4.007,3.471L4,15.241a1.469,1.469,0,0,0,1.464,1.471H14.3a1.476,1.476,0,0,0,1.471-1.471V6.414Zm1.471,11.77H6.942V12.3h5.885Zm0-2.942H6.942V9.356h5.885ZM10.62,7.149V3.1l4.046,4.046Z",
    transform: "translate(-4 -2)",
    fill: "#F79F15"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconmaterialDescriptionYellow);
export default __webpack_public_path__ + "static/media/Icon material-description-yellow.760d32586f9699c525aed0b7aa776027.svg";
export { ForwardRef as ReactComponent };